import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const withdrawalThresholdsColumns: GridColumn[] = [
  {
    title: 'Payment Provider',
    field: 'paymentProviderMethod.name',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem?.paymentProviderMethod?.name}</td>
    },
    filterable: false,
    show: true,
  },
  {
    title: 'Currency',
    field: 'currency.id',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.currency?.id) {
        return <td />
      }

      return <td>{props.dataItem.currency.id}</td>
    },
    filterable: false,
    show: true,
  },
  {
    title: 'Bank Code',
    field: 'bankCode',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem?.bankCode}</td>
    },
    filterable: false,
    show: true,
  },
  {
    title: 'Amount',
    field: 'amount',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem?.amount}</td>
    },
    filterable: false,
    show: true,
  },
]

export default withdrawalThresholdsColumns
